import styled from '@emotion/styled';
import Surface from '@via-profit/ui-kit/Surface';

/** Карточка слева: вкладки и под ними поиск или маршрут. */
const SidePanel = styled(Surface)`
  position: absolute;
  top: 16px;
  left: 16px;
  width: 400px;
  max-width: calc(100vw - 32px);
  z-index: 10;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.16);
  font-size: 14px;
`;

export default SidePanel;
